import React from "react";
import {
  Wallet, CreditCard, TrendingDown, Briefcase, PiggyBank,
  ShieldAlert, GraduationCap, Home, Users, Lock, TrendingUp,
  HeartPulse, Heart, HeartHandshake, Car,
} from "lucide-react";
import { CTAButton, Reveal, SectionTitle } from "./common";
import { useContent } from "../../context/ContentContext";

const ICONS = {
  Wallet, CreditCard, TrendingDown, Briefcase, PiggyBank,
  ShieldAlert, GraduationCap, Home, Users, Lock,
  HeartPulse, Heart, HeartHandshake, Car,
};

export const FinancialProblems = () => {
  const { financial } = useContent();
  const problems = financial.problems || [];
  return (
    <section className="py-16 bg-[#FBF5E9]">
      <div className="max-w-6xl mx-auto px-4">
        <SectionTitle kicker={financial.kicker || "Does This Sound Like You?"} title={financial.title || "The Money Worries That Keep You Awake At Night"} />
        <p className="text-center text-[#6b5647] max-w-2xl mx-auto -mt-4 mb-10 leading-relaxed">{financial.subtitle}</p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {problems.map((p, i) => {
            const Icon = ICONS[p.icon] || Wallet;
            return (
              <Reveal key={i} delay={(i % 3) * 80}>
                <div className="h-full flex gap-4 bg-white rounded-xl border border-[#e7d9b8] p-5 shadow-sm hover:shadow-md hover:border-[#C9992B]/60 transition-all">
                  <div className="shrink-0 w-11 h-11 rounded-lg bg-[#F3E7CE] flex items-center justify-center">
                    <Icon className="w-6 h-6 text-[#B8860B]" />
                  </div>
                  <p className="text-[#4a3a2e] text-sm leading-relaxed italic">&ldquo;{p.text}&rdquo;</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal>
          <div className="mt-10 rounded-2xl bg-[#5A0B1D] text-center px-6 py-9">
            <TrendingUp className="w-9 h-9 text-[#E9C767] mx-auto mb-3" />
            <h3 className="font-display text-xl sm:text-2xl font-bold text-[#F4E3B8]">{financial.bannerTitle}</h3>
            <p className="text-[#e0c9ac] text-sm sm:text-base mt-3 max-w-2xl mx-auto">{financial.bannerText}</p>
            <div className="mt-7 flex justify-center"><CTAButton sub="Begin your wealth journey today" /></div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
